export default {
  templates: {
    // Traditional Wedding Tasks
    'choose-venue': {
      title: 'Choisir le lieu de réception',
      description: 'Rechercher et visiter différents lieux pour la cérémonie et la réception'
    },
    'define-budget': {
      title: 'Définir le budget global',
      description: 'Établir un budget détaillé pour chaque poste de dépense'
    },
    'choose-date': {
      title: 'Choisir la date',
      description: 'Fixer la date du mariage en fonction des disponibilités du lieu et des prestataires principaux'
    },
    'book-venue': {
      title: 'Réserver le lieu de réception',
      description: 'Visiter et réserver le lieu pour la cérémonie et la réception'
    },
    'choose-photographer': {
      title: 'Choisir le photographe',
      description: 'Rechercher et rencontrer des photographes pour sélectionner celui de votre mariage'
    },
    'choose-caterer': {
      title: 'Choisir le traiteur',
      description: 'Rechercher et sélectionner un traiteur pour la réception'
    },
    'choose-florist': {
      title: 'Choisir le fleuriste',
      description: 'Sélectionner un fleuriste pour les décorations de cérémonie et réception'
    },
    'choose-music': {
      title: 'Choisir la musique',
      description: 'Sélectionner des musiciens ou DJ pour la cérémonie et la réception'
    },
    'choose-transport': {
      title: 'Choisir le transport',
      description: 'Réserver le transport pour le jour du mariage'
    },
    'choose-attire': {
      title: 'Choisir les tenues',
      description: 'Acheter la robe de mariée et le costume du marié'
    },
    'choose-beauty': {
      title: 'Choisir les services de beauté',
      description: 'Réserver les services de coiffure et maquillage pour le jour du mariage'
    },
    'send-invitations': {
      title: 'Envoyer les invitations',
      description: 'Concevoir et envoyer les invitations de mariage aux invités'
    },
    'plan-honeymoon': {
      title: 'Planifier la lune de miel',
      description: 'Rechercher et réserver la destination de lune de miel'
    },
    'legal-formalities': {
      title: 'Formalités légales',
      description: 'Compléter toutes les exigences légales pour le mariage'
    }
  }
};
